import React from "react";

//external components
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

//components
import EmployeeTimesheet from "../../Employee-timesheet";
import EmployeeAttendanceSheet from "../../Employee-attendance-sheet";
import TimeByProject from "../../Time-by-project";
import TimeByEmployee from "../../Time-by-employee";
import TimeByExternalReference from "../../Time-by-external-reference";
import AttendanceByEmployee from "../../Attendance-by-employee";
import ExcelReport from "../../Excel-report";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 0.5, pb: 0.5 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default function ReportsTabRoutes({ value }) {
  return (
    <>
      <TabPanel value={value} index={0}>
        <EmployeeTimesheet />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <EmployeeAttendanceSheet />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <AttendanceByEmployee fromReports />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <TimeByEmployee fromReports />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <TimeByProject fromReports />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <TimeByProject fromReports timeByContractor/>
      </TabPanel>
      <TabPanel value={value} index={6}>
        <TimeByExternalReference fromReports />
      </TabPanel>
      <TabPanel value={value} index={7}>
        <ExcelReport />
      </TabPanel>
    </>
  );
}
